<template>
  <div id="page-wrap">
    <div class="container" v-if="showCodeStatus">
      <div class="codebox">
        <h1 class="title">请输入提取密码</h1>
        <div class="codebody">
          <div class="form-group">
            <input
              class="form-control"
              type="password"
              v-model.trim="code"
              readonly
              onfocus="this.removeAttribute('readonly');"
              name="code"
              data-vv-as="密码 "
              v-validate="{ required: true }"
              @keyup.enter="setShareCode"
            />
            <button class="btn btn-primary" type="button" @click="setShareCode">
              提取文件
            </button>
          </div>
          <span class="help-block" v-show="errors.has('code')">{{
            errors.first("code")
          }}</span>
        </div>
      </div>
    </div>
    <div class="container" v-if="expiredStatus">
      <div class="cont">
        <div class="drive">
          <div class="lists">
            <div class="list-content">
              <div class="nofile">
                <div class="pic">
                  <img src="@/assets/images/timeout.svg" />
                </div>
                <h4>{{ errMsg }}</h4>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="errStatus">
      <div class="cont">
        <div class="drive">
          <div class="lists">
            <div class="list-content">
              <div class="nofile">
                <div class="pic">
                  <img src="@/assets/images/timeout.svg" />
                </div>
                <h4>{{ errMsg }}</h4>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid group-wrap" v-if="showLinkInfoStatus">
      <div class="container">
        <div class="sharelink-file">
          <div class="filename">
            <div class="file-icon">
              <svg aria-hidden="true" class="icon">
                <use xlink:href="#icon-folder-zy" />
              </svg>
            </div>
            <p>{{ shareInfo.link_title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="showLinkInfoStatus">
      <div class="sharelink-box">
        <div class="cont">
          <div class="filepath">
            <a @click="getInfoByFatherId('up')" :class="{ 'no-click': noClick }"
              >返回上一级</a
            >
            <span class="line">|</span>
            <a @click="getAllInfo">全部文件</a>
            <span v-for="lel in level" :key="lel.number">
              <i class="ti-angle-right"></i>
              <a @click="getInfoByFatherId(lel)">{{ lel.name }}</a>
            </span>
          </div>
          <div class="drive">
            <div class="lists">
              <div class="list-header" :class="{ act: selectedCount }">
                <div
                  class="item-header"
                  :class="[
                    { 'item-check-header-selected2': selectedCount },
                    { 'item-check-header-no-selected2': !selectedCount },
                  ]"
                >
                  <div class="checkbox" @click="toggleSelectAll">
                    <i class="ti-check"></i>
                  </div>
                  <div
                    class="item-selected-number"
                    style="display: block"
                    v-show="selectedCount"
                  >
                    已选择{{ selectedCount }}项
                  </div>
                </div>
                <div
                  v-for="header in headers"
                  :key="header.id"
                  class="item-header"
                  :class="'item-' + header.class + '-header'"
                  v-show="!selectedCount"
                  @click="sortByHeader(header.id)"
                >
                  <div class="file-icon" v-show="header.id === 1">
                    <i class="fa fa-file-o"></i>
                  </div>
                  <p>{{ header.title }}</p>
                  <span
                    class="sort"
                    :class="header.sort"
                    v-show="header.showSort"
                  ></span>
                </div>
                <div
                  class="item-selected-menu"
                  style="display: block"
                  v-show="selectedCount"
                >
                  <a v-show="showMultipleMenu" @click="downloadSendSelecteds">
                    <i class="ti-download"></i>
                    下载
                  </a>
                </div>
              </div>
              <div class="list-content">
                <div
                  class="itemlist"
                  v-for="data in datas"
                  :key="data.number"
                  :class="{ act: data.isSelected ? true : false }"
                >
                  <div class="item-check2">
                    <div class="checkbox" @click="selectRow(data)">
                      <i class="ti-check"></i>
                    </div>
                  </div>
                  <div class="item-name">
                    <div class="file-icon" @click.stop="handleClickIcon(data)">
                      <svg aria-hidden="true" class="icon">
                        <use
                          :xlink:href="
                            '#icon-' +
                            getIcon(data.type, data.file_type, data.file_ext)
                          "
                        />
                      </svg>
                    </div>
                    <p>
                      <a
                        @click.stop="handleClickIcon(data)"
                        :title="data | formatData"
                        >{{ data | formatData }}</a
                      >
                    </p>
                    <i
                      class="glyphicon glyphicon-lock"
                      :title="data.lock_reason ? data.lock_reason : '锁定'"
                      v-if="
                        data.is_lock === true || data.review_status === 'block'
                      "
                    ></i>
                  </div>
                  <div class="item-time">{{ data | bytesToSize }}</div>
                  <div class="item-share2">
                    {{ data.last_update_date ? data.last_update_date : "-" }}
                  </div>
                  <div class="item-menu">
                    <a
                      class="hidden-xs"
                      @click="download(data)"
                      v-if="data.type === 'file'"
                    >
                      <i class="ti-download" title="下载"></i>
                    </a>
                  </div>
                </div>
                <div class="loadingbox" v-show="loading">
                  <section class="loading Animation1">
                    <section class="shape shape-1"></section>
                    <section class="shape shape-2"></section>
                    <section class="shape shape-3"></section>
                    <section class="shape shape-4"></section>
                  </section>
                  <h4>正在加载，请稍后……</h4>
                </div>
                <div class="nofile" v-show="nothing">
                  <div class="pic">
                    <img src="@/assets/images/nofile.svg" />
                  </div>
                  <h4>这里还没任何文件</h4>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user">
          <div class="head">
            <div class="avator">
              <img :src="shareInfo.link_creater_avatar" />
            </div>
            <div class="info">
              <h3>{{ shareInfo.link_creater_name }}</h3>
            </div>
          </div>
        </div>
      </div>
      <markdownPreview
        :detail="detail"
        dialogStatus="view"
        :linkShareNumber="listQuery.link_number"
      ></markdownPreview>
      <videoPreview
        :detail="detail"
        :linkShareNumber="listQuery.link_number"
      ></videoPreview>
      <audioPreview
        :detail="detail"
        :linkShareNumber="listQuery.link_number"
      ></audioPreview>
      <imgPreview
        :imgs="imgs"
        :linkShareNumber="listQuery.link_number"
      ></imgPreview>
      <txtPreview
        :detail="detail"
        :linkShareNumber="listQuery.link_number"
      ></txtPreview>
      <officePreview
        :detail="detail"
        :linkShareNumber="listQuery.link_number"
      ></officePreview>
      <pdfPreview
        :detail="detail"
        dialogStatus="view"
        :linkShareNumber="listQuery.link_number"
      ></pdfPreview>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getIcon, getPreviewType } from "@/utils/icon";
import {
  linkTargetConstraint,
  linkTargetInfo,
  linkTargetResourceList,
  linkTargetDownload,
  linkTargetPreview,
} from "@/api/share/share";
import { previewTxts } from "@/config/index";
import { bytesToSize, transcodeStatusFilter, formatData } from "@/utils/index";

export default {
  name: "SendLink",
  components: {
    markdownPreview: () => import("./TablePreview/markdownPreview"),
    videoPreview: () => import("./TablePreview/videoPreview"),
    audioPreview: () => import("./TablePreview/audioPreview"),
    imgPreview: () => import("./TablePreview/imgPreview"),
    txtPreview: () => import("./TablePreview/txtPreview"),
    officePreview: () => import("./TablePreview/officePreview"),
    pdfPreview: () => import("./TablePreview/pdfPreview"),
  },
  data() {
    return {
      errStatus: false,
      expiredStatus: false, // 是否过期
      errMsg: "",
      code: "",
      showLinkInfoStatus: false,
      showCodeStatus: false,
      loading: false,
      nothing: false,
      selectedFolder: null,
      form: {
        type: 1,
        message: null,
        numbers: [],
      },
      shareInfo: {},
      sort: {},
      level: [],
      imgs: [],
      selectedDatas: [],
      datas: [],
      PreviewType: "unknow",
      detail: {},
      listQuery: {
        link_number: null,
        link_resource_number: null,
        is_rec: "false",
        link_constraint: {
          password: null,
        },
      },
      headers: [
        {
          id: 1,
          title: "名称",
          class: "name",
          sort: "asc",
          showSort: true,
          field: "name",
        },
        {
          id: 2,
          title: "大小",
          class: "time",
          sort: "des",
          showSort: false,
          field: "bytes",
        },
        {
          id: 3,
          title: "修改日期",
          class: "share",
          sort: "des",
          showSort: false,
          field: "last_update_date",
        },
      ],
    };
  },
  created() {
    this.sort = this.headers[0];
    this.listQuery.link_number = this.$route.params.link_number;
    this.getLinkTargetConstraint();
  },
  filters: {
    transcodeStatusFilter: transcodeStatusFilter,
    formatData: formatData,
    bytesToSize: bytesToSize,
  },
  methods: {
    // 获取发布具有的策略
    getLinkTargetConstraint() {
      linkTargetConstraint(this.listQuery.link_number)
        .then((res) => {
          if (res.status_code === 200) {
            // 检测password策略，如果有，则获取password
            if (res.entity.is_password) {
              if (Cookies.get(this.listQuery.link_number)) {
                this.init();
              } else {
                this.showCodeStatus = true;
              }
            } else {
              this.getLinkTargetInfo();
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 有密码时，进入页面初始化请求，不显示错误信息
    init() {
      linkTargetInfo({
        link_number: this.listQuery.link_number,
        link_constraint: {
          password: Cookies.get(this.listQuery.link_number),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.shareInfo = res.entity;
            this.getLinkResourceList();
          } else if (res.status_code === 439) {
            // 过期
            this.showCodeStatus = false;
            this.errMsg = res.message;
            this.expiredStatus = true;
          } else if (res.status_code === 434) {
            // 密码错误
            this.showCodeStatus = true;
          } else {
            this.showCodeStatus = false;
            this.errStatus = true;
            this.errMsg = res.message;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 存储&验证password
    setShareCode() {
      this.$validator.validate("code").then((valid) => {
        if (valid) {
          Cookies.set(this.listQuery.link_number, this.code);
          this.getLinkTargetInfo();
        }
      });
    },
    // 获取发布详情
    getLinkTargetInfo() {
      linkTargetInfo({
        link_number: this.listQuery.link_number,
        link_constraint: {
          password: Cookies.get(this.listQuery.link_number),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.shareInfo = res.entity;
            this.getLinkResourceList();
          } else if (res.status_code === 439) {
            // 过期
            this.showCodeStatus = false;
            this.errMsg = res.message;
            this.expiredStatus = true;
          } else if (res.status_code === 434) {
            // 密码错误
            this.showCodeStatus = true;
            this.errors.add({
              field: "code",
              msg: res.message,
            });
          } else {
            this.showCodeStatus = false;
            this.errStatus = true;
            this.errMsg = res.message;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取发布资源列表
    getLinkResourceList() {
      this.selectedDatas = [];
      this.datas = [];
      this.loading = true;
      this.nothing = false;
      this.listQuery.link_constraint.password = Cookies.get(
        this.listQuery.link_number
      );
      linkTargetResourceList(this.listQuery)
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            if (res.entity.length) {
              this.datas = res.entity.map((data) => {
                data.isSelected = false;
                return data;
              });
              this.sortBy();
            } else {
              this.nothing = true;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    sortByHeader(id) {
      let that = this;
      this.headers.map(function (item) {
        if (item.id === id) {
          that.sort = item;
          item.showSort = true;
          item.sort = item.sort === "des" ? "asc" : "des";
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
      this.sortBy();
    },
    sortBy() {
      let that = this;
      switch (this.sort.id) {
        case 1:
          this.datas.sort(function (x, y) {
            let ind = x[that.sort.field].localeCompare(y[that.sort.field]);
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
        case 2:
          this.datas.sort(function (x, y) {
            let ind = x[that.sort.field] - y[that.sort.field];
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
        case 3:
          this.datas.sort(function (x, y) {
            let ind =
              new Date(x[that.sort.field]).getTime() -
              new Date(y[that.sort.field]).getTime();
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
      }
      const files = this.datas.filter((item) => {
        return item.type === "file";
      });

      const folders = this.datas.filter((item) => {
        return item.type === "folder";
      });

      this.datas = folders.concat(files);
    },
    getAllInfo() {
      this.level = [];
      this.listQuery.link_resource_number = null;
      this.getLinkResourceList();
    },
    handleClickIcon(data) {
      if (data.type === "file") {
        this.preview(data);
      } else {
        this.getInfoByFatherId(data);
      }
    },
    getInfoByFatherId(data) {
      this.selectedDatas = [];
      let index = this.level.indexOf(data);
      if (index > -1) {
        this.level.splice(index + 1, this.level.length - index - 1);
      } else if (data === "up") {
        if (this.noClick) {
          return false;
        } else {
          this.level.pop();
        }
      } else {
        this.level.push(data);
      }
      this.listQuery.link_resource_number =
        this.level.length === 0
          ? null
          : this.level[this.level.length - 1].number;
      this.getLinkResourceList();
    },
    preview(data) {
      this.detail = data;
      let type = getPreviewType(data.type, data.file_type, data.file_ext);
      this.PreviewType = type;
      switch (type) {
        case "mp4":
          if (
            data.transcode_status == "none" ||
            data.transcode_status == "success"
          ) {
            this.getPreviewPath(data).then(() => {
              $("#video_preview").modal("show");
            });
          } else if (data.transcode_status == "wait") {
            this.$message({
              type: "warning",
              message: "视频暂未转码，请先转码，转码完成后即可播放",
            });
          } else if (data.transcode_status == "progess") {
            this.$message({
              type: "warning",
              message: "视频正在转码，请稍等",
            });
          } else if (data.transcode_status == "fail") {
            this.$message({
              type: "warning",
              message: "视频转码失败，无法播放",
            });
          } else if (data.transcode_status == "notran") {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
            });
          }
          break;
        case "audio":
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#audio_preview").modal("show");
            });
          });
          break;
        case "office":
          this.getPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#office_preview").modal("show");
            });
          });
          break;
        case "pdf":
          this.getPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#pdf_preview").modal("show");
            });
          });
          break;
        case "markdown":
          this.getPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#markdown_preview").modal("show");
            });
          });
          break;
        case "img":
          this.getPreviewPath(data).then(() => {
            this.imgs = this.datas
              .filter((item) => {
                return item.file_type === "image";
              })
              .map((file) => {
                if (file.number === data.number) {
                  file.show = true;
                } else {
                  file.show = false;
                }
                return file;
              });
            this.$nextTick(() => {
              $("#img_preview").modal("show");
            });
          });
          break;
        case "txt":
          this.getPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#txt_preview").modal("show");
            });
          });
          break;
        default:
          if (previewTxts.includes(data.file_ext)) {
            this.getPreviewPath(data).then(() => {
              this.$nextTick(() => {
                $("#txt_preview").modal("show");
              });
            });
          } else {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
            });
          }
          break;
      }
    },
    download(data) {
      let params = {
        link_number: this.listQuery.link_number,
        link_constraint: {
          password: Cookies.get(this.listQuery.link_number),
        },
        link_resources_list: [data.number],
      };
      linkTargetDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 下载资源
    downloadSendSelecteds() {
      let lockFile = this.selectedDatas.find(
        (item) => item.is_lock || item.review_status === "block"
      );
      if (lockFile && lockFile.is_lock) {
        this.$message({
          type: "warning",
          message: `文件【${lockFile.name}】已被锁定，锁定原因：${lockFile.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (lockFile && lockFile.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (this.selectedCount > 1) {
        this.$confirm({
          type: "confirm",
          content: `确定批量下载这${this.selectedCount}个文件吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            this.downloadLinkSelectedsByStep();
          })
          .catch(() => {});
      } else {
        this.downloadLinkSelectedsByStep();
      }
    },
    downloadLinkSelectedsByStep() {
      this.selectedDatas.map((data) => {
        let params = {
          link_number: this.listQuery.link_number,
          link_constraint: {
            password: Cookies.get(this.listQuery.link_number),
          },
          link_resources_list: [data.number],
        };
        linkTargetDownload(params)
          .then((res) => {
            if (res.status_code === 200) {
              const iframe = window.document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = res.entity[data.number] + "&download=download";
              document.body.appendChild(iframe);
              // 10s之后删除
              setTimeout(() => {
                iframe.remove();
              }, 10000);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    // 预览发布资源
    getPreviewPath(data) {
      return new Promise((resolve) => {
        linkTargetPreview({
          link_number: this.listQuery.link_number,
          link_resource_number: this.detail.number,
          link_constraint: {
            password: Cookies.get(this.listQuery.link_number),
          },
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              if (data.review_status === "block") {
                this.$message({
                  type: "warning",
                  message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else if (res.status_code === 410) {
              this.$message({
                type: "error",
                message: res.message,
              });
              let index = this.datas.indexOf(data);
              this.datas.splice(index, 1);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    selectRow(data) {
      if (data.isSelected) {
        let index = this.selectedDatas.indexOf(data);
        data.isSelected = false;
        this.selectedDatas.splice(index, 1);
      } else {
        data.isSelected = true;
        this.selectedDatas.push(data);
      }
    },
    toggleSelectAll() {
      let status = this.selectedDatas.length === 0;
      if (status) {
        this.selectedDatas = this.datas.map((data) => {
          return data;
        });
      } else {
        this.selectedDatas = [];
      }
      this.datas.map((data) => {
        data.isSelected = status ? true : false;
        return data;
      });
    },
  },
  computed: {
    noClick() {
      return this.level.length ? false : true;
    },
    selectedCount() {
      return this.selectedDatas.length;
    },
    showMultipleMenu() {
      return this.selectedDatas.every((item) => item.type === "file");
    },
  },
};
</script>

<style scoped>
/*发布链接*/
.drive .lists .item-check-header-selected2 {
  float: left;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
}
.drive .lists .item-check-header-no-selected2,
.drive .lists .item-check2 {
  float: left;
  width: 5%;
  padding-right: 10px;
  padding-left: 10px;
}
.sharelink-box {
  width: 100%; /*background: #fff;*/
  min-height: 500px;
  float: left;
  position: relative; /*box-shadow: rgba(0,0,0,.1) 0 0 10px;*/
}
.sharelink-box .cont {
  width: calc(100% - 260px);
  float: left;
}
.sharelink-box .user {
  width: 200px;
  float: right;
  height: 100%;
  background: #f9f9f9;
  position: absolute;
  right: 0;
  top: 0;
  border-left: #e1e1e1 solid 1px;
}
.sharelink-box .cont .head {
  width: 100%;
  height: 40px;
}
.sharelink-box .cont .filepath {
  margin: 10px 0 30px 0;
}

.sharelink-box .cont .drive .lists .item-name-header,
.sharelink-box .cont .drive .lists .item-name {
  width: 49%;
}
.sharelink-box .user .head {
  padding: 0 30px;
  position: relative; /*border-bottom: #e1e1e1 solid 1px;*/
}
.sharelink-box .user .head .avator {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  float: left;
}
.sharelink-box .user .head .avator img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.sharelink-box .user .head .info {
  width: auto;
  padding-left: 20px;
  height: 60px;
  float: left;
}
.sharelink-box .user .head .info h3 {
  font-size: 16px;
  margin: 10px 0 5px 0;
}
.sharelink-box .user .head .info p {
  font-size: 12px;
  color: #999;
}

.sharelink-file {
  padding: 50px 0;
  height: 140px;
  width: calc(100% - 0px);
  float: left;
}
.sharelink-user {
  width: 300px;
  float: right;
}
.sharelink-file .filename {
  width: 60%;
  float: left;
  line-height: 40px;
}
.sharelink-file .filename .file-icon {
  width: 40px;
  height: 40px;
  display: block;
  float: left;
}
.sharelink-file .filename .file-icon .icon {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.sharelink-file .filename p {
  width: calc(100% - 40px);
  font-size: 20px;
  padding-left: 15px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.no-click {
  color: #ddd;
  cursor: default;
}
.item-share2 {
  float: left;
  width: 18%;
}
</style>